import { AngelInvestorType as AngelInvestor } from 'packages/angel_investors_repository';
import { FieldType } from '../../../../types/reduxTypes/ActionTypes/AngelInvestorsTypes';

export const types = {
  SET_FIELD: 'SET_FIELD',
  SET_ALL: 'SET_ALL',
}

export type SetAllType = {
  angelInvestor: AngelInvestor,
};

export type SetFieldType = {
  field: FieldType,
  value: string | Blob,
}

export const setAll = (payload: SetAllType) => ({
  type: types.SET_ALL,
  payload,
});

export const setField = (payload: SetFieldType) => ({
  type: types.SET_FIELD,
  payload,
});
